import React from 'react';
import Modal from 'react-responsive-modal';
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailShareButton,
  EmailIcon,
  LinkedinShareButton,
  LinkedinIcon
} from 'react-share';

//TODO:: ADICIONAR UTM_SOURCE NOS LINKS
export default function SharedModal({open, close, slug}){
  return(
    <Modal open={open} onClose={close} center className="w-50">
    <div className="flex-row justify-around" style={{width: '350px', height: '50px', marginRight: '20px'}}>
      <FacebookShareButton className="pointer" url={`${window.location.origin}/artigos/${slug}`}><FacebookIcon size={30} round={true}/></FacebookShareButton>
      <WhatsappShareButton className="pointer" url={`${window.location.origin}/artigos/${slug}`}><WhatsappIcon size={30} round={true}/></WhatsappShareButton>
      <TwitterShareButton className="pointer" url={`${window.location.origin}/artigos/${slug}`}><TwitterIcon size={30} round={true}/></TwitterShareButton>
      <EmailShareButton className="pointer" url={`${window.location.origin}/artigos/${slug}`}><EmailIcon size={30} round={true}/></EmailShareButton>
      <LinkedinShareButton className="pointer" url={`${window.location.origin}/artigos/${slug}`}><LinkedinIcon size={30} round={true}/></LinkedinShareButton>
    </div>
  </Modal>
  )
}